<template>
  <div class="recent-mention-tag">
 
    <div class="tag-list">
                  <ul>
          <li v-for="tag in recenttags" :key="tag" class="tag-default tag-pill tag-outline">
             <a  @click.prevent='createTab(tag,"search","symbol")' ><span v-html="tag"></span></a>
           
          </li>
          </ul>

    </div>

  </div>
</template>
<script>
import { mapActions } from 'vuex'
import {  ADDTAB, RESET_SEARCH_FILTER, SET_SEARCH_SYMBOL } from '@/store/actions.type'
import ThePlaceHolder from '@/components/ThePlaceHolder'
import localStorage from '@/api/localStorage'
export default {
  name: 'recent-mention',
  props: {
    recenttags: {
      type: Object,
      default: () => {}
    },
    showPlaceholder: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      isTags:true
    }
  },
  components: {
    ThePlaceHolder
  },
  computed: {
  },
  methods: {
    		...mapActions({
      			createRvTab: ADDTAB,
			resetfilters: RESET_SEARCH_FILTER,
			setSearchsymbol: SET_SEARCH_SYMBOL
		}),

    		async createTab(categoryName, type, post) {
			var tabobj = {}
			tabobj['type'] = type
			tabobj['categoryName'] = categoryName
			tabobj['post'] = post
			this.createRvTab(tabobj)
			if (type == 'search') {
                localStorage.savelocalStorage( 'serachResultload', 'true' )
				this.resetfilters()
				if (post == 'symbol') {
					this.setSearchsymbol(categoryName)
				}
			}
			// events.selectCurrentAcative(currentTab)
		},
  }
}
</script>
<style>
.tag-default {
    color: #fff !important;
    font-size: 0.8rem;
    padding-top: 0.1rem;
    padding-bottom: 0.1rem;
    white-space: nowrap;
    margin-right: 3px;
    margin-bottom: 0.2rem;
    display: inline-block;
}
.tag-default {
    background-color: #818a91;
}
.tag-pill {
    padding-right: 0.6em;
    padding-left: 0.6em;
    border-radius: 0.2rem;
}
</style>


// WEBPACK FOOTER //
// src/components/recentmention.vue